import React, { useState } from 'react';
import Sidebar from '../../../components/Sidebar';
import AdNav from '../../../components/AdNav';
// import "../../../components/ad.css"
import '../../../components/ad.css';
import { useSelector } from 'react-redux';
import { useInitialdataGetQuery, useUploadExcelMutation, useWithdrawUpdateMutation } from '../../../slice/authApiSlice';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';




const columns = [
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'code', label: 'College Type', minWidth: 200 },
  {
    id: 'population',
    label: 'City',
    // minWidth: 170,
    align: 'left',
 
  },
  {
    id: 'size',
    label: 'State',
    // minWidth: 170,
    align: 'left',
 
  },
  {
    id: 'density',
    label: 'Ranking',
    // minWidth: 170,
    align: 'left',
  
  },
];


const columnsJob = [
  { id: 'name', label: 'Title', minWidth: 170 },
  { id: 'code', label: 'Exprience required', minWidth: 200 },
  {
    id: 'population',
    label: 'Location',
    // minWidth: 170,
    align: 'left',
 
  },
  {
    id: 'size',
    label: 'Number of Position',
    // minWidth: 170,
    align: 'left',
    
  },
  {
    id: 'density',
    label: 'Total applied',
    align: 'left',

  },
];


const columnsCalls = [
  { id: 'name', label: 'User'},
  { id: 'code', label: 'Counsellor',},
  {
    id: 'population',
    label: 'Duration',
    // minWidth: 170,
    align: 'left',
   
  },
  {
    id: 'size',
    label: 'Room_Id',
    // minWidth: 170,
    align: 'left',
  
  },
  {
    id: 'density',
    label: 'Status',
    align: 'left',
   
  },
];



const columnsWithdraw = [
  { id: 'name', label: 'Name'},
  { id: 'code', label: 'UPI ID',},
  {
    id: 'population',
    label: 'Amount',
    // minWidth: 170,
    align: 'left',
   
  },
  {
    id: 'size',
    label: 'Req_Id',
    // minWidth: 170,
    align: 'left',
  
  },
  {
    id: 'density',
    label: 'Status',
    align: 'left',
   
  },
];


const columnsPayment = [
  { id: 'name', label: 'Name'},
  { id: 'code', label: 'Amount',},
  {
    id: 'population',
    label: 'Order Id',
    // minWidth: 170,
    align: 'left',
   
  },
  {
    id: 'size',
    label: 'Date',
    // minWidth: 170,
    align: 'left',
  
  },
  {
    id: 'density',
    label: 'Status',
    align: 'left',
   
  },
];



const columnsVideos = [
  { id: 'name', label: 'User',  },
  { id: 'code', label: 'Counsellor' },
  {
    id: 'population',
    label: 'Slot',
    // minWidth: 170,
    align: 'left',
   
  },
  {
    id: 'size',
    label: 'Date',
    // minWidth: 170,
    align: 'left',
  
  },
  {
    id: 'density',
    label: 'Status',
    align: 'left',
   
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}


export default function UserNavbar() {
  
  const [collapsed, setCollapsed] = useState(true);
   const user = useSelector((state) => state.auth.userInfo);
     const {data, isLoading} = useInitialdataGetQuery();
     const [withdrawUpdate] = useWithdrawUpdateMutation();
       const [file, setFile] = useState(null);
       const [uploadExcel, { isLoading: upLoading }] = useUploadExcelMutation();
     console.log(data);
     
  const handleAccept = async (id) => {
  await withdrawUpdate(id);
};


  const handleUpload = async () => {
    if (!file) return alert("Please choose a file");

    const formData = new FormData();
    formData.append("excel", file);

    try {
      await uploadExcel(formData);
      alert("Upload successful");
      setFile(null);
    } catch (error) {
      console.error(error);
      alert("Upload failed");
    }
  };
     

  return (
    <div >
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div>
        <AdNav collapsed={collapsed} />
     
      </div>
      
    </div>
  );
}
